import Marquee from "react-fast-marquee";

const ITEMS = [
  "Utsav Flowers",
  "Est. 1999",
  "Fresh Cut Flowers",
  "Wedding Décor",
  "Birthdays",
  "Engagements",
  "Corporate Events",
  "Dibrugarh · Assam",
];

export default function EditorialMarquee() {
  return (
    <div className="overflow-hidden border-y border-forest/10 bg-cream py-7" data-testid="editorial-marquee">
      <Marquee speed={22} gradient={false}>
        {ITEMS.map((item) => (
          <span key={item} className="mx-10 flex items-center gap-20">
            <span className="whitespace-nowrap font-serif text-3xl italic text-forest/80 md:text-4xl">
              {item}
            </span>
            <span className="text-xl text-marigold">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
